module.exports = __webpack_public_path__ + "img/creator.df221b56.svg";